var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',[_c('v-card',[_c('v-card-title',[_vm._v("Informação")]),_c('v-card-text',[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c('v-card-action',[_c('v-spacer'),_c('v-btn',{attrs:{"text":"","color":"success"}},[_vm._v("Continuar")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }